import axios from "axios";
import { url, AuthHeader } from "../../utils/_exports";
const apiURL = "projects";

/*
 * Get all projects from all tenants
 * Used to get all projects in timewriting and useAllProjects hook
 */
export const getAllProjects = (
	tenantKey: any,
	tenantList: any,
	filter: any = {}
) => {
	return new Promise((resolve, reject) => {
		axios
			.post(
				`${url}/${tenantKey}/${apiURL}/get-all-projects`,
				{ tenantList, filter },
				AuthHeader
			)
			.then((_data: any) => {
				resolve(_data.data);
			})
			.catch((e: any) => {
				reject(e?.response?.data?.error);
			});
	});
};

export const getAllUserProjects = (
	tenantKey: string,
	tenantList: string[],
	filter: any = {},
	user: any
) => {
	return new Promise((resolve, reject) => {
		axios
			.post(
				`${url}/${tenantKey}/${apiURL}/get-all-user-projects`,
				{ tenantList, filter, user },
				AuthHeader
			)
			.then((_data: any) => {
				resolve(_data.data);
			})
			.catch((e: any) => {
				reject(e?.response?.data?.error);
			});
	});
};

export const getAllProjectsByApprover = (
	tenantKey: any,
	tenantList: any,
	user: any
) => {
	return new Promise((resolve, reject) => {
		axios
			.post(
				`${url}/${tenantKey}/${apiURL}/get-all-projects-by-approver`,
				{ tenantList, user },
				AuthHeader
			)
			.then((_data: any) => {
				resolve(_data.data);
			})
			.catch((e: any) => {
				reject(e?.response?.data?.error);
			});
	});
};

export const getProjects = (tenantKey: any, filter: any = {}) => {
	const _filter = { ...filter, is_removed: false };
	return new Promise((resolve, reject) => {
		//console.log(url, tenantKey, apiURL);
		axios
			.get(`${url}/${tenantKey}/${apiURL}`, {
				...AuthHeader,
				params: { filter: _filter },
			})
			.then((_data: any) => {
				if (_data?.data && _data.data.length) {
					resolve(_data.data);
				} else {
					resolve(null);
				}
			})
			.catch((e: any) => {
				reject(e);
			});
	});
};

export const getProject = (tenantKey: any, code: any) => {
	return new Promise((resolve, reject) => {
		if (!code) {
			resolve(null);
		} else {
			axios
				.get(`${url}/${tenantKey}/${apiURL}/project`, {
					...AuthHeader,
					params: {
						filter: {
							project_code: code,
						},
					},
				})
				.then((_data: any) => {
					if (_data?.data) {
						resolve(_data.data);
					} else {
						resolve(null);
					}
				})
				.catch((e: any) => {
					reject(e);
				});
		}
	});
};

export const addProjectItem = async (tenantKey: any, data: any, user: any) => {
	try {
		const request_body = {
			data: data,
			user: user,
		};
		const response = await axios.post(
			`${url}/${tenantKey}/${apiURL}/add`,
			request_body,
			AuthHeader
		);
		return response.data;
	} catch (error: any) {
		throw error;
	}
};

export const updateProjectItem = (
	tenantKey: any,
	code: any,
	data: any,
	initialData: any,
	user: any,
	formList: any = null
) => {
	return new Promise((resolve, reject) => {
		axios
			.put(
				`${url}/${tenantKey}/${apiURL}/update`,
				{
					filter: { project_code: code },
					data,
					initialData,
					user,
					formList,
					options: { upsert: true, new: true },
				},
				AuthHeader
			)
			.then((_data: any) => {
				resolve(_data.data);
			})
			.catch((e: any) => {
				reject(e?.response?.data?.error);
			});
	});
};

export const updateProjectStatus = (
	tenantKey: any,
	code: any,
	operation_code: any,
	data: any
) => {
	return new Promise((resolve, reject) => {
		axios
			.put(
				`${url}/${tenantKey}/${apiURL}/update-status`,
				{
					filter: { project_code: code },
					phaseFilter: { operation_code: operation_code },
					data: data,
				},
				AuthHeader
			)
			.then((_data: any) => {
				console.log(_data.data);
				if (
					(_data.data != "taskless" || _data.data != "phaseless") &&
					_data.data
				) {
					resolve(_data.data);
				} else {
					reject(false);
				}
			})
			.catch((e: any) => {
				reject(e?.response?.data?.error);
			});
	});
};

export const deleteProjectItem = (tenantKey: any, uuid: any) => {
	return new Promise((resolve, reject) => {
		axios
			.delete(`${url}/${tenantKey}/${apiURL}`, {
				params: {
					filter: {
						uuid: uuid,
					},
				},
				...AuthHeader,
			})
			.then((_data) => {
				resolve(true);
			})
			.catch((e: any) => {
				reject(e?.response?.data?.error);
			});
	});
};

export const getCampaignTasks = (tenantKey: any, project_id: string) => {
	console.log("getCampaignTasks project_id: ", project_id);
	return new Promise((resolve, reject) => {
		axios
			.get(`${url}/${tenantKey}/${apiURL}/campaign-tasks`, {
				...AuthHeader,
				params: {
					project_id: project_id,
				},
			})
			.then((_data: any) => {
				resolve(_data.data);
			})
			.catch((e: any) => {
				reject(e);
			});
	});
};
